import React from "react"
import { Icon, Input, List, Segment } from "semantic-ui-react"
import { ReactComponent as DevicesIcon } from "../../../Icons/devices-icon.svg"
import BifrostButton from "../../BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostList from "../../BifrostElementComponent/BifrostList/BifrostList"
import TransferDeviceToOrgModal from "../../TransferDeviceToOrgModal/template/TransferDeviceToOrgModal"
import { useDeviceStructure } from "../hooks/useDeviceStructure"

/**
 * DeviceStructure component is used to render the device structure.
 * @function useDeviceStructure - Custom hook for the device structure component. It returns the state and functions to handle the search and fetch the device structure data.
 * @component {JSX.Element} Input - Semantic UI React component used to render the search bar.
 * @component {JSX.Element} BifrostButton - Renders the button with refresh icon. It will trigger the getDeviceStructureByOrgId function to refresh the device structure data.
 * @component {JSX.Element} BifrostList - Renders the list of devices. It needs to pass the device data to the structure of the list
 * @returns {JSX.Element} DeviceStructure
 */
const DeviceStructure = () => {
	const { state, handleSearch, getDeviceStructureByOrgId } = useDeviceStructure()

	return (
		<Segment style={{ width: "60%", margin: "0 auto" }}>
			<div className="bifrost-table-searchbar-refresh" style={{}}>
				<Input icon={"search"} onChange={(e) => handleSearch(e)} />
				<BifrostButton onClick={() => getDeviceStructureByOrgId()} size="medium" style={{ marginLeft: "10px", marginTop: "1px", marginBottom: "1px" }}>
					<Icon name="refresh" style={{ margin: "0px", opacity: "1" }} />
				</BifrostButton>
			</div>
			<BifrostList
				list={{
					struct: "devices",
					name: "Devices",
					path: "/devices/",
					icon: (
						<List.Icon>
							<DevicesIcon />
						</List.Icon>
					),
					description: state.deviceData.length,
					operationButton: <TransferDeviceToOrgModal type="org" refresh={getDeviceStructureByOrgId} device={state.deviceData} />,
					content: state.searchResult ? state.searchResult : state.deviceData,
					isloading: state.isLoading,
					isError: state.isError,
					errorMessage: state.errorMessage,
					tab: "Devices"
				}}
			/>
		</Segment>
	)
}

export default DeviceStructure
